import Button from '../buttons/Button';

export default function HomeLink() {
    return (
        <div className="home-link">
            <Button link="https://sifrovka.cz" className="primary-button">
                Více
            </Button>
        </div>
    );
}
